import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Save, Upload } from "lucide-react";

const roleAccent = { admin: "#1B1E23", pm: "#0E62C4" };

export default function MeinProfil() {
  const { user } = useAuth();
  const [me, setMe] = useState(null);
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/auth/me");
      setMe(data);
    })();
  }, []);

  const upd = (patch) => setMe((s) => ({ ...s, ...patch }));

  const handleFoto = (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    const r = new FileReader();
    r.onload = () => upd({ foto: r.result });
    r.readAsDataURL(f);
  };

  const save = async () => {
    if (pw1 && pw1 !== pw2) { setMsg("Passwörter stimmen nicht überein."); return; }
    setBusy(true); setMsg("");
    try {
      const payload = { name: me.name, telefon: me.telefon || "", foto: me.foto || "" };
      if (pw1) payload.password = pw1;
      await api.put("/me/profil", payload);
      setPw1(""); setPw2("");
      setMsg("Profil gespeichert.");
    } catch (e) {
      setMsg(e.response?.data?.detail || "Fehler beim Speichern.");
    } finally { setBusy(false); }
  };

  if (!me) return <div className="mono-label">Lade Profil…</div>;
  const accent = roleAccent[user?.rolle] || "#1B1E23";

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <div className="mono-label" style={{ color: accent, opacity: 1 }}>{user?.rolle}</div>
          <h1 className="font-archivo font-bold text-4xl mt-1">Mein Profil</h1>
        </div>
        <button onClick={save} disabled={busy} data-testid="me-save" className="inline-flex items-center gap-2 px-4 py-2.5 bg-ink text-white rounded-sm hover:bg-black disabled:opacity-60">
          <Save size={14} /> {busy ? "Speichern…" : "Speichern"}
        </button>
      </div>

      {msg && <div className="mb-4 px-4 py-2 rounded-sm text-sm border" style={{
        color: msg.includes("gespeichert") ? "#157A4A" : "#BE2E6C",
        backgroundColor: msg.includes("gespeichert") ? "#DDEEE3" : "#F7DDE7",
        borderColor: msg.includes("gespeichert") ? "#157A4A44" : "#BE2E6C44",
      }}>{msg}</div>}

      <div className="paper-card p-8">
        <div className="flex gap-6 items-start mb-8 pb-8 border-b border-line">
          <div>
            <div className="w-28 h-28 rounded-sm border border-line overflow-hidden bg-paper flex items-center justify-center">
              {me.foto ? <img src={me.foto} alt="Foto" className="w-full h-full object-cover" data-testid="me-foto" /> : (
                <div className="font-mono text-2xl" style={{ color: accent }}>
                  {(me.name || "?").split(" ").map((s) => s[0]).slice(0, 2).join("")}
                </div>
              )}
            </div>
            <label className="mt-2 inline-flex items-center gap-1 text-xs cursor-pointer text-brunnerBlue hover:underline">
              <Upload size={11} /> Foto ändern
              <input type="file" accept="image/*" onChange={handleFoto} className="hidden" data-testid="me-foto-input" />
            </label>
          </div>
          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="mono-label block mb-1">Name</label>
              <input value={me.name || ""} onChange={(e) => upd({ name: e.target.value })} data-testid="me-name"
                className="w-full px-3 py-2 border border-line rounded-sm bg-white" />
            </div>
            <div>
              <label className="mono-label block mb-1">Rolle</label>
              <input value={me.rolle} disabled className="w-full px-3 py-2 border border-line rounded-sm bg-paper" />
            </div>
            <div>
              <label className="mono-label block mb-1">E-Mail</label>
              <input value={me.email} disabled className="w-full px-3 py-2 border border-line rounded-sm bg-paper" />
            </div>
            <div>
              <label className="mono-label block mb-1">Telefon</label>
              <input value={me.telefon || ""} onChange={(e) => upd({ telefon: e.target.value })} data-testid="me-telefon"
                className="w-full px-3 py-2 border border-line rounded-sm bg-white" />
            </div>
          </div>
        </div>

        <div>
          <h3 className="font-archivo font-bold text-lg mb-1">Passwort ändern</h3>
          <div className="mono-label mb-3">Leer lassen, um Passwort nicht zu ändern.</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-lg">
            <div>
              <label className="mono-label block mb-1">Neues Passwort (min. 6)</label>
              <input type="password" value={pw1} onChange={(e) => setPw1(e.target.value)} data-testid="me-pw1"
                className="w-full px-3 py-2 border border-line rounded-sm bg-white" />
            </div>
            <div>
              <label className="mono-label block mb-1">Wiederholen</label>
              <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="me-pw2"
                className="w-full px-3 py-2 border border-line rounded-sm bg-white" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
